module.exports = __webpack_public_path__ + "static/media/default_user_image.4a3c9f0c.svg";